import { render, staticRenderFns } from "./AppSignupFooter.vue?vue&type=template&id=2ca4894b&"
import script from "./AppSignupFooter.vue?vue&type=script&lang=ts&"
export * from "./AppSignupFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports